enum LoadingSpinnerSize {
	XS = 'xs',
	SM = 'sm',
	MD = 'md',
	LG = 'lg',
}

enum LoadingSpinnerColor {
	PRIMARY = 'primary',
	SECONDARY = 'secondary',
	ACCENT = 'accent',
	WHITE = 'white',
}

export { LoadingSpinnerSize, LoadingSpinnerColor };
